// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- ActionButton.css --- */

/* 1. ESTILOS BASE Y VARIANTES */
.action-button-dynamic {
    height: 32px;
    font-size: 13px;
    font-weight: 600;
    border-radius: 10px;
    border: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: background-color 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
    text-transform: none;
    outline: none;
}

/* Botón negro (por defecto) */
.btn-1 {
    background-color: #111;
    color: #fff;
}
.btn-1:hover:not(:disabled) {
    background-color: #535353 !important;
    color: #fff;
    /* No shadow, solo aclarar un poco el fondo */
}

/* Botón claro (type 2) */
.btn-2 {
    background-color: #f5f5f5;
    color: #222;
    border: 1px solid #bbb;
    box-shadow: none;
}
.btn-2:hover:not(:disabled) {
    background-color: #e5e5e5 !important;
}

/* 3. ESTILO DEL SPINNER DE CARGA (Genérico) */
.action-button-spinner {
    width: 14px;
    height: 14px;
    border: 2px solid rgba(255, 255, 255, 0.4); /* Blanco semi-transparente */
    border-top: 2px solid #fff; /* Blanco sólido */
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

/* 4. AJUSTE PARA SPINNER EN BOTÓN CLARO (type='2') */
.action-button-spinner.spinner-dark {
    border: 2px solid rgba(79, 79, 79, 0.4); /* Gris oscuro semi-transparente */
    border-top: 2px solid #4f4f4f; /* Gris oscuro sólido */
}


/* 5. ANIMACIÓN GLOBAL */
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}`, "",{"version":3,"sources":["webpack://./src/components/Admin/Inputs/ActionButton.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B,gCAAgC;AAChC;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,+EAA+E;IAC/E,oBAAoB;IACpB,aAAa;AACjB;;AAEA,8BAA8B;AAC9B;IACI,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,oCAAoC;IACpC,WAAW;IACX,6CAA6C;AACjD;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;IACzB,WAAW;IACX,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,oCAAoC;AACxC;;AAEA,8CAA8C;AAC9C;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C,EAAE,6BAA6B;IACzE,0BAA0B,EAAE,kBAAkB;IAC9C,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA,qDAAqD;AACrD;IACI,uCAAuC,EAAE,kCAAkC;IAC3E,6BAA6B,EAAE,uBAAuB;AAC1D;;;AAGA,wBAAwB;AACxB;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC","sourcesContent":["/* --- ActionButton.css --- */\n\n/* 1. ESTILOS BASE Y VARIANTES */\n.action-button-dynamic {\n    height: 32px;\n    font-size: 13px;\n    font-weight: 600;\n    border-radius: 10px;\n    border: none;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    transition: background-color 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;\n    text-transform: none;\n    outline: none;\n}\n\n/* Botón negro (por defecto) */\n.btn-1 {\n    background-color: #111;\n    color: #fff;\n}\n.btn-1:hover:not(:disabled) {\n    background-color: #535353 !important;\n    color: #fff;\n    /* No shadow, solo aclarar un poco el fondo */\n}\n\n/* Botón claro (type 2) */\n.btn-2 {\n    background-color: #f5f5f5;\n    color: #222;\n    border: 1px solid #bbb;\n    box-shadow: none;\n}\n.btn-2:hover:not(:disabled) {\n    background-color: #e5e5e5 !important;\n}\n\n/* 3. ESTILO DEL SPINNER DE CARGA (Genérico) */\n.action-button-spinner {\n    width: 14px;\n    height: 14px;\n    border: 2px solid rgba(255, 255, 255, 0.4); /* Blanco semi-transparente */\n    border-top: 2px solid #fff; /* Blanco sólido */\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n}\n\n/* 4. AJUSTE PARA SPINNER EN BOTÓN CLARO (type='2') */\n.action-button-spinner.spinner-dark {\n    border: 2px solid rgba(79, 79, 79, 0.4); /* Gris oscuro semi-transparente */\n    border-top: 2px solid #4f4f4f; /* Gris oscuro sólido */\n}\n\n\n/* 5. ANIMACIÓN GLOBAL */\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
